import { LinkConfig } from '@zipari/shared-ds-util-navigation';
import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { ExternalSiteModalConfig } from '../../chords/external-site-warning-modal/external-site-warning-modal.model';

export interface ActionItemConfig extends LinkConfig {
  icon?: string;
  createdProp?: string;
  selectedProp?: string;
  externalSiteModalConfig?: ExternalSiteModalConfig;
}

export interface ActionButtonConfig extends ButtonConfig {
  label: string;
  leftIcon?: string;
  rightIcon?: string;
}
/**
 * @example
 * {
        actionButton: {
            leftIcon: 'download',
            rightIcon: '',
            label: 'Actions',
            level: ButtonLevels.low,
        },
        actions: [
            {
                label: 'Google',
                icon: 'close',
                useExternalSiteModal: true,
                externalLink: 'https://google.com',
                externalSiteModalConfig: {
                    title: 'title',
                    description: 'description',
                    footerCancelButton: 'Cancel',
                    footerProceedButton: 'Proceed',
                    type: ModalTypes.popup,
                    backdrop: true,
                    clickOutside: true,
                    header: {
                        title: null,
                        icon: null,
                        showClose: null,
                    },
                    altStyle: false,
                },
            },
            {
                label: 'Add Notes',
                icon: 'close',
            },
            {
                label: 'Download a PDF of this claim',
                icon: 'close',
            },
        ],
    };

 */
export interface ActionButtonMetaConfig {
  actionButton: ActionButtonConfig;
  actions: ActionItemConfig[];
}
export enum ActionsEnum {
  exportCsv = 'exportCsv',
  exportPdf = 'exportPdf',
}
